<template>
    <div class="app-container">
      <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
              <BjInput v-model="queryParams.skuCode" :placeholder="$t('goodsPage.skuCode')" @keyup.enter.native="handleQuery"/>
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="onAdd()">{{ $t('addText') }}</el-button>
            <el-button type="primary" class="main-btn" @click="onAllTrigger('table')">{{ $t('BusinessStockSearch.triggerAll') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
                <template v-else-if="col.prop === 'skuCode'">
                  <span>{{ scope.row.skuCode }}</span>
                  <BjCopyIcon :copy="scope.row.skuCode" />
                </template>
                <template v-else-if="col.prop == 'content'">{{ scope.row.argumentMap.remark }}</template>
                <template v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <template>
                  <el-button type="text" class="edit-btn" @click="onTrigger(props.row)">{{ $t('BusinessStockSearch.trigger') }}</el-button>
                  <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                  <el-button type="text" class="delete-btn" @click="onDel(props.row)">{{ $t('delText') }}</el-button>
                </template>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 新增编辑弹窗 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="800px" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="form" :model="form" label-position="top" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
                <BjSelectLov v-model="form.cusId" :option-list="customerList" @change="changeCustomer" :placeholder="$t('customerNameText')" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
                <BjSelectLov v-model="form.skuCode" :disabled="!form.cusId" :option-list="skuCodeList" :placeholder="$t('goodsPage.skuCode')"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('BusinessStockSearch.threshold')" prop="threshold">
                <BjInputNumber v-model="form.threshold" :placeholder="$t('BusinessStockSearch.threshold')"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('BusinessStockSearch.ticketContent')" prop="argument.remark">
                <BjInput v-model="form.argument.remark" type="textarea" :rows="5" :maxlength="MAX_LENGTH.PRIORITY" show-word-limit autosize :placeholder="$t('inputText')" clearable />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onSave()">{{ $t('okText') }}</el-button>
        </div>
      </el-dialog>
  
    </div>
  </template>
  <script>
  import { thirdApi,goodsApi } from '@/api';
  import pageMiXin from '@/utils/page-mixin.js';
  const getDefaultForm = () => {
    return {
      id: null,
      cusId: null,
      skuCode: null,
      threshold: null,
      argument: {remark:null},
    };
  };
  
  export default {
    name: 'BusinessStockInventoryWarning',
    components: {},
    mixins: [pageMiXin],
    data() {
      const thresholdValidate = (rule, value, callback) => {
        setTimeout(() => {
          if (!value || value=='0' || value==0) {
            callback(new Error(this.$t('inputText')));
          } else{
            callback();
          }
        }, 300)
      };
      return {
        colSpan: 4,
        selection: true,
        queryApi: thirdApi.getStorkMonitorList,
        queryParams: {
          skuCode: null,
        },
        labelList: [
          { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, },
          { label: this.$t('goodsPage.skuCode'), prop: 'skuCode', isCheck: true, disabled: false },
          { label: this.$t('BusinessStockSearch.threshold'), prop: 'threshold', isCheck: true, disabled: false },
          { label: this.$t('BusinessStockSearch.ticketContent'), prop: 'content', isCheck: true, disabled: false },
          { label: this.$t('BusinessStockSearch.ticket'), prop: 'workNo', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width:160 },
        ],
  
        // 弹窗相关数据
        dialogTitle:null,
        dialogFormVisible: false,
        form: getDefaultForm(),
        skuCodeList:[],
        rules: {
          cusId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          skuCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          threshold: [{ required: true, validator: thresholdValidate, trigger: 'blur' }],
          'argument.remark': [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        },
      };
    },
    mounted() {
      // this.getStaffNameList();
      // this.getStaffDeptPull();
    },
    computed:{
      customerList() {
        return this.$store.getters.customerList;
      },
    },
    methods: {
      // 触发全部 按钮
      onAllTrigger(){
        thirdApi.goStorkMonitorAllButton().then(res => {
          if(!res.failed){
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }
        });
      },
      // 触发全部 按钮
      onTrigger(row){
        thirdApi.goStorkMonitorButton({id: row.id}).then(res => {
          if(!res.failed){
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          }
        });
      },
      // 新增
      onAdd(){
        this.dialogTitle = this.$t('addText')
        this.dialogFormVisible = true;
      },
      // 编辑
      onEdit(row){
        this.dialogTitle = this.$t('editText')
        const rowData = JSON.parse(JSON.stringify(row));
        this.form = {
          id: rowData.id,
          cusId: rowData.cusId,
          skuCode: rowData.skuCode,
          threshold: rowData.threshold,
          argument: {remark:rowData.argumentMap.remark},
        };
        this.dialogFormVisible = true;
      },
      // 选择客户后 获取skuCode下拉列表
      changeCustomer(n,m){
        this.form.skuCode = null
        this.form.cusId = m.cusId
        goodsApi.getSku({ cusId: this.form.cusId, setFlag: 0, status: [3, 4, 5] }).then(res=>{
          console.log(res,'res');
          this.skuCodeList = res.content?.map(item=>{
            return {label:item.skuCode,value:item.skuCode}
          })
        })
      },
      // 保存弹窗数据 并 关闭编辑弹窗
      onSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if(!this.form.id){
              thirdApi.addStorkMonitorList(this.form).then(res => {
                console.log(res,'res');
                if(!res.failed){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.handleClose()
                  this.reFresh();
                }
              });
            }else{
              thirdApi.editStorkMonitorList(this.form).then(res => {
                console.log(res,'res');
                if(!res.failed){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.handleClose()
                  this.reFresh();
                }
              });
            }
          }
        })
      },
      /** 关闭弹窗 清空数据 */
      handleClose() {
        this.form = getDefaultForm();
        this.$refs.form.resetFields();
        this.dialogFormVisible = false;
      },
      // 删除按钮
      onDel(row) {
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            thirdApi.delStorkMonitorList({id: row.id}).then(res => {
              if(!res.failed){
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.reFresh();
              }
            });
          })
          .catch(() => { });
      },
      /** 重置按钮操作 */
      beforeResetSearch() {
        if(this.deptDis){
          this.queryParams.staffDepartment = this.staffDepartmentDisvalue
        }else{
          this.queryParams.staffDepartment = null
        }
        // this.queryParamsTime_expensePeriod = [];
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .el-icon-s-flag {
    float: right;
    line-height: 34px;
  }
  
  .ts-divider {
    padding: 5px 0;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  }
  </style>
  